import axios from "axios";
import { getCookie } from "BridgeFunction";
export const request = (
  method = "get",
  request = "/",
  payload = {},
  isToken=false,
  headerOptions = {},
  is_uat = false
) => {
  let url;
  if (!is_uat) {
    url = process.env.REACT_APP_API_ENDPOINT + request;
  } else {
    url = process.env.REACT_APP_UAT_API_HOST + request;
  }
  const authorization = isToken
    ? {
        Authorization: `Bearer ${getCookie(process.env.REACT_APP_DEV_MCOOKIE)}`,
      }
    : {};
  const options = {
    method,
    url,
    data: payload,
    headers: {
      ...authorization,
      ...headerOptions,
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          const data = error.response.data;
          // error.response.data.message = error?.response?.data?.message
          //   ? error.response.data.message
          //   : "Something went wrong, Please Try Again";
          // if (data.code === 401) {
          //   window.location.href = "/login";
          // }
          if (error?.response?.data === "Unauthorized") {
            window.location.href = "/login";
          }
          reject(data);
        } else {
          reject("Network Error");
        }
      });
  });
};
